import WildcatPhoneNumberInput, {
  PhoneNumberInputProps,
} from '@ancon/wildcat-ui/web/orderweb/PhoneNumberInput'
import '@ancon/wildcat-ui/web/orderweb/PhoneNumberInput/PhoneNumberInput.css'
import { useMemo } from 'react'
import useTranslation from 'next-translate/useTranslation'

import { SupportedLanguage } from '../constants'

/**
 * Flags served from our own origin (copied by `yarn flags`) instead of
 * react-phone-number-input's default, purecatamphetamine.github.io
 */
const flagUrl = '/flags/3x2/{XX}.svg'

function PhoneNumberInput(props: PhoneNumberInputProps) {
  const { lang } = useTranslation()

  const defaultCountryCode = useMemo<'SE' | 'NO'>(() => {
    switch (lang) {
      case SupportedLanguage.Norwegian:
        return 'NO'

      /** Fallback to sweden */
      case SupportedLanguage.English:
      case SupportedLanguage.Swedish:
      default:
        return 'SE'
    }
  }, [lang])

  return (
    <WildcatPhoneNumberInput
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      defaultCountry={defaultCountryCode}
      flagUrl={flagUrl}
    />
  )
}

export type { PhoneNumberInputProps }

export default PhoneNumberInput
